import React from "react";
import { LOGOS } from "../config";
import "./WelcomeScreen.css";
import Avatar from "./Avatar";

export default function WelcomeScreen({ chat_widget_icon, statusLabel }) {
  const isConnected = statusLabel === "Connected";

  return (
    <div className="welcome-screen">
      <div className="welcome-body">
        <div className="welcome-logo">
          {isConnected ? (
            <Avatar
              src={chat_widget_icon || LOGOS.logo}
              alt="Arya"
              className="welcome-logo-img"
            />
          ) : (
            <div className="skeleton logo" />
          )}
        </div>
        <div className="welcome-text">
          <div className="skeleton line medium" />
          <div className="skeleton line medium" />
          <div className="skeleton line short" />
        </div>
      </div>
    </div>
  );
}
